angular
  .module('olivioConfiguratorApp', [
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngRoute',
    'ngDragDrop',
    'pascalprecht.translate'
  ])
  .config(['$routeProvider', function ($routeProvider) {
    // TODO configure $routeProvider through reading StepService.configurationSteps (adding there a route-subobject)
    $routeProvider
      .when('/product', {
        id: 'product',
        headerVisible: true,
        templateUrl: 'views/product.html',
        controller: 'ProductCtrl',
        reloadOnSearch: false
      })
      .when('/design', {
        id: 'design',
        headerVisible: false,
        templateUrl: 'views/design.html',
        controller: 'DesignCtrl',
        reloadOnSearch: false
      })
      .when('/charging', {
        id: 'charging',
        headerVisible: false,
        templateUrl: 'views/charging.html',
        controller: 'ChargingCtrl',
        reloadOnSearch: false
      })
      .when('/assembly', {
        id: 'assembly',
        headerVisible: true,
        templateUrl: 'views/assembly.html',
        controller: 'AssemblyCtrl',
        reloadOnSearch: false
      })
      .when('/distribution', {
        id: 'distribution',
        headerVisible: true,
        templateUrl: 'views/distribution.html',
        controller: 'DistributionCtrl',
        reloadOnSearch: false
      })
      .when('/color', {
        id: 'color',
        headerVisible: true,
        templateUrl: 'views/color.html',
        controller: 'ColorCtrl',
        reloadOnSearch: false
      })
      .when('/power', {
        id: 'power',
        headerVisible: true,
        templateUrl: 'views/power.html',
        controller: 'PowerCtrl',
        reloadOnSearch: false
      })
      .when('/gobo', {
        id: 'gobo',
        headerVisible: true,
        templateUrl: 'views/gobo.html',
        controller: 'GoboCtrl',
        reloadOnSearch: false
      })
      .when('/details', {
        id: 'details',
        headerVisible: true,
        templateUrl: 'views/details.html',
        controller: 'DetailsCtrl',
        reloadOnSearch: false
      })
      .when('/checkout', {
        id: 'checkout',
        headerVisible: true,
        templateUrl: 'views/checkout.html',
        controller: 'CheckoutCtrl',
        reloadOnSearch: false
      })
      .otherwise({
        redirectTo: '/product'
      });
  }])
  .run(['$rootScope', '$location', 'Model', 'StepService', 'Storage', 'env', function ($rootScope, $location, Model, StepService, Storage, env) {
    $rootScope.env = env;
    $rootScope.restoreStateToken = $location.search().token;
    $rootScope.restoreConfigurationToken = $location.search().configurationNumber;

    $rootScope.$safeApply = function ($scope, fn) {
      fn = fn || function () {
      };
      if ($scope.$$phase) {
        fn();
      } else {
        $scope.$apply(fn);
      }
    };

    var originalLocation = $location.path().substr(1);

    function goToOriginalLocation() {
      StepService.gotoStep(originalLocation);
    }

    // Anmerkung: Wenn die App mit einem für das gespeicherte Modell ungültigen Pfad aufgerufen wird,
    //    wird dann zwar dorthin zu gehen versucht, aber der StepCtrl korrigiert das in $on('$routeChangeStart', ...)
    if ($rootScope.restoreStateToken) {
      Storage.restoreStateFromServer($rootScope.restoreStateToken)
        .then(goToOriginalLocation, Storage.restoreStateFromLocalStorage);
    } else if ($rootScope.restoreConfigurationToken) {
      Storage.restoreConfigurationFromServer($rootScope.restoreConfigurationToken)
        .then(function () {
          $location.search('configurationNumber', null);
        }, Storage.restoreStateFromLocalStorage);
    } else if ($location.search().reset) {
      $location.search('reset', null);
    } else {
      Storage.restoreStateFromLocalStorage();
    }

    window.onbeforeunload = function () {
      Storage.saveStateToLocalStorage();
    };
  }]);
